import {loadGoogleFont, preloadGoogleFonts} from '../utils/fontLoader';

export const APP_NAME = 'pixel_studio';
export const APP_VERSION = '1.0.0';
export const SCHEMA_VERSION = 3;
export const SCHEMA_VERSION_KEY = 'pixel_studio_schema_version';
export const LOG_PREFIX = `${APP_NAME}_log：`;

export const OBJECT_DEFAULT_CONFIG = {
    // controls
    borderColor: '#333366',
    selectionKey: 'ctrlKey',
    borderScaleFactor: 2,
    cornerStrokeColor: '#2222',
    cornerColor: '#333366',
    cornerSize: 12,
    cornerStyle: 'circle',
    transparentCorners: false,
    padding: 0,
    centeredScaling: false,
    strokeUniform: true,
    paintFirst: 'stroke',
};

export const TEXTBOX_DEFAULT_CONFIG = {
    // styles
    fill: '#000000',
    fontWeight: 'normal',
    fontSize: 50,
    lineHeight: 1.3,
    textAlign: 'center',
    fontFamily: 'SmileySans',
    // size
    width: 150,
    splitByGrapheme: true,
};

export const getGoogleFonts = async () => {
    const response = await fetch(
        'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyAVCH5E99hBuXY0J-ISVWdN69vEb-4A_6o',
    );
    const data = await response.json();
    return data.items;
};

export const generateFontPresetFamilyList = async () => {
    const fonts = await getGoogleFonts();
    const fontFamilies = fonts.map((font: any) => font.family);
    preloadGoogleFonts(fontFamilies);
    return fonts.map((font: any) => ({
        label: <span style={{fontFamily: font.family, fontSize: 12}}>{font.family}</span>,
        value: font.family,
    }));
};

export const FONT_PRESET_FAMILY_LIST = [
    {
        label: <span style={{fontFamily: 'Inter', fontSize: 12}}>Inter</span>,
        value: 'Inter',
    },
    {
        label: <span style={{fontFamily: 'Inter-Black', fontSize: 12}}>Inter-Black</span>,
        value: 'Inter-Black',
    },
    {
        label: <span style={{fontFamily: 'Inter-Bold', fontSize: 12}}>Inter-Bold</span>,
        value: 'Inter-Bold',
    },
    {
        label: <span style={{fontFamily: 'Inter-ExtraBold', fontSize: 12}}>Inter-ExtraBold</span>,
        value: 'Inter-ExtraBold',
    },
    {
        label: <span style={{fontFamily: 'Inter-ExtraLight', fontSize: 12}}>Inter-ExtraLight</span>,
        value: 'Inter-ExtraLight',
    },
    {
        label: <span style={{fontFamily: 'Inter-Light', fontSize: 12}}>Inter-Light</span>,
        value: 'Inter-Light',
    },
    {
        label: <span style={{fontFamily: 'Inter-Medium', fontSize: 12}}>Inter-Medium</span>,
        value: 'Inter-Medium',
    },
    {
        label: <span style={{fontFamily: 'Inter-Regular', fontSize: 12}}>Inter-Regular</span>,
        value: 'Inter-Regular',
    },
    {
        label: <span style={{fontFamily: 'Inter-SemiBold', fontSize: 12}}>Inter-SemiBold</span>,
        value: 'Inter-SemiBold',
    },
    {
        label: <span style={{fontFamily: 'Inter-Thin', fontSize: 12}}>Inter-Thin</span>,
        value: 'Inter-Thin',
    },
    {
        label: <span style={{fontFamily: 'Roboto', fontSize: 12}}>Roboto</span>,
        value: 'Roboto',
    },
    {
        label: <span style={{fontFamily: 'SmileySans', fontSize: 12}}>SmileySans</span>,
        value: 'SmileySans',
    },
    {
        label: <span style={{fontFamily: 'SourceHanSans', fontSize: 12}}>Source Han Sans</span>,
        value: 'SourceHanSans',
    },
    {
        label: <span style={{fontFamily: 'AmberyGardenRegular', fontSize: 12}}>AmberyGardenRegular</span>,
        value: 'AmberyGardenRegular',
    },
    {
        label: <span style={{fontFamily: 'BarelyEnoughRegular', fontSize: 12}}>BarelyEnoughRegular</span>,
        value: 'BarelyEnoughRegular',
    },
    {
        label: <span style={{fontFamily: 'BlueBubbles', fontSize: 12}}>BlueBubbles</span>,
        value: 'BlueBubbles',
    },
    {
        label: <span style={{fontFamily: 'GirlySunrise', fontSize: 12}}>GirlySunrise</span>,
        value: 'GirlySunrise',
    },
    {
        label: <span style={{fontFamily: 'GladlyAcceptRegular', fontSize: 12}}>GladlyAcceptRegular</span>,
        value: 'GladlyAcceptRegular',
    },
    {
        label: <span style={{fontFamily: 'GrislyBeastRegular', fontSize: 12}}>GrislyBeastRegular</span>,
        value: 'GrislyBeastRegular',
    },
    {
        label: <span style={{fontFamily: 'LeavesWreath', fontSize: 12}}>LeavesWreath</span>,
        value: 'LeavesWreath',
    },
    {
        label: <span style={{fontFamily: 'LoftyGoalsRegular', fontSize: 12}}>LoftyGoalsRegular</span>,
        value: 'LoftyGoalsRegular',
    },
    {
        label: <span style={{fontFamily: 'MangabeyRegular', fontSize: 12}}>MangabeyRegular</span>,
        value: 'MangabeyRegular',
    },
    {
        label: <span style={{fontFamily: 'MotleyForcesRegular', fontSize: 12}}>MotleyForcesRegular</span>,
        value: 'MotleyForcesRegular',
    },
    {
        label: <span style={{fontFamily: 'PacifyAngryRegular', fontSize: 12}}>PacifyAngryRegular</span>,
        value: 'PacifyAngryRegular',
    },
    {
        label: <span style={{fontFamily: 'PartyConfettiRegular', fontSize: 12}}>PartyConfettiRegular</span>,
        value: 'PartyConfettiRegular',
    },
    {
        label: <span style={{fontFamily: 'SinglyLinkedRegular', fontSize: 12}}>SinglyLinkedRegular</span>,
        value: 'SinglyLinkedRegular',
    },
    {
        label: <span style={{fontFamily: 'SparkyStonesRegular', fontSize: 12}}>SparkyStonesRegular</span>,
        value: 'SparkyStonesRegular',
    },
    {
        label: <span style={{fontFamily: 'SunnySpellsBasicRegular', fontSize: 12}}>SunnySpellsBasicRegular</span>,
        value: 'SunnySpellsBasicRegular',
    },
    {
        label: <span style={{fontFamily: 'SuperBoys', fontSize: 12}}>SuperBoys</span>,
        value: 'SuperBoys',
    },
    {
        label: <span style={{fontFamily: 'SuperBubble', fontSize: 12}}>SuperBubble</span>,
        value: 'SuperBubble',
    },
    {
        label: <span style={{fontFamily: 'SuperCacao', fontSize: 12}}>SuperCacao</span>,
        value: 'SuperCacao',
    },
    {
        label: <span style={{fontFamily: 'SuperCandy', fontSize: 12}}>SuperCandy</span>,
        value: 'SuperCandy',
    },
    {
        label: <span style={{fontFamily: 'SuperCarbon', fontSize: 12}}>SuperCarbon</span>,
        value: 'SuperCarbon',
    },
    {
        label: <span style={{fontFamily: 'SuperCereal', fontSize: 12}}>SuperCereal</span>,
        value: 'SuperCereal',
    },
    {
        label: <span style={{fontFamily: 'SuperChalk', fontSize: 12}}>SuperChalk</span>,
        value: 'SuperChalk',
    },
    {
        label: <span style={{fontFamily: 'SuperDream', fontSize: 12}}>SuperDream</span>,
        value: 'SuperDream',
    },
    {
        label: <span style={{fontFamily: 'SuperEasy', fontSize: 12}}>Super Easy</span>,
        value: 'SuperEasy',
    },
    {
        label: <span style={{fontFamily: 'SuperEnjoy', fontSize: 12}}>Super Enjoy</span>,
        value: 'SuperEnjoy',
    },
    {
        label: <span style={{fontFamily: 'SuperFoods', fontSize: 12}}>Super Foods</span>,
        value: 'SuperFoods',
    },
    {
        label: <span style={{fontFamily: 'SuperFuggy', fontSize: 12}}>Super Fuggy</span>,
        value: 'SuperFuggy',
    },
    {
        label: <span style={{fontFamily: 'SuperFunky', fontSize: 12}}>Super Funky</span>,
        value: 'SuperFunky',
    },
    {
        label: <span style={{fontFamily: 'SuperFunnel', fontSize: 12}}>Super Funnel</span>,
        value: 'SuperFunnel',
    },
    {
        label: <span style={{fontFamily: 'SuperFuntime', fontSize: 12}}>Super Funtime</span>,
        value: 'SuperFuntime',
    },
    {
        label: <span style={{fontFamily: 'SuperGlue', fontSize: 12}}>Super Glue</span>,
        value: 'SuperGlue',
    },
    {
        label: <span style={{fontFamily: 'SuperGlueOutline', fontSize: 12}}>Super Glue Outline</span>,
        value: 'SuperGlueOutline',
    },
    {
        label: <span style={{fontFamily: 'SuperMilk', fontSize: 12}}>Super Milk</span>,
        value: 'SuperMilk',
    },
    {
        label: <span style={{fontFamily: 'SuperPencil', fontSize: 12}}>Super Pencil</span>,
        value: 'Super Pencil',
    },
    {
        label: <span style={{fontFamily: 'SuperPlants', fontSize: 12}}>Super Plants</span>,
        value: 'SuperPlants',
    },
    {
        label: <span style={{fontFamily: 'SuperReduce', fontSize: 12}}>Super Reduce</span>,
        value: 'SuperReduce',
    },
    {
        label: <span style={{fontFamily: 'SuperSalad', fontSize: 12}}>Super Salad</span>,
        value: 'SuperSalad',
    },
    {
        label: <span style={{fontFamily: 'SuperSunshine', fontSize: 12}}>Super Sunshine</span>,
        value: 'SuperSunshine',
    },
    {
        label: <span style={{fontFamily: 'SupplyCenter', fontSize: 12}}>Supply Center</span>,
        value: 'SupplyCenter',
    },
    {
        label: <span style={{fontFamily: 'WigglyCurvesRegular', fontSize: 12}}>Wiggly Curves Regular</span>,
        value: 'WigglyCurvesRegular',
    },
    {
        label: <span style={{fontFamily: 'YeastyFlavorsRegular', fontSize: 12}}>Yeasty Flavors Regular</span>,
        value: 'YeastyFlavorsRegular',
    },
];

export const SKETCH_ID = 'pixel_studio-sketch';

export const PIXEL_STUDIO_CUSTOM_PROPS = [
    'id',
    'pixel_studio_desc',
    'selectable',
    'hasControls',
    'sub_type',
    'imageSource',
    'imageBorder',
    'oldArrowInfo',
    'fontFamily',
    'pathAlign',
    'fill',
    'fontWeight',
    'fontSize',
    'lineHeight',
    'textAlign',
    'fontFamily',
    'width',
    'splitByGrapheme',
    'originalImageUrl',
    'image',
    'isBackgroundImage',
    'originalSource',
    'isCdnImage',
    'isBgRemoved',
];
